(function () {
	'use strict';
	$(document).ready(function () {
		objectFitImages();
		const $dropdown = $('.dropdown');

		function updateHeaderHeight() {
			const height = $('.header-container')[0].getBoundingClientRect().height;
			const $breadcrumbContainer = $('.breadcrumb-container');
			if ($breadcrumbContainer.length) {
				$breadcrumbContainer.css('--header-height', `${height}px`);
			}
			return height;
		}

		$(window).on('load resize', updateHeaderHeight);

		$(window).scroll(function () {
			var $nav = $(".header-container");
			$nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());

			if (document.documentElement.dataset.fontSize === 'max') {
				setTimeout(() => {
					updateHeaderHeight();
				}, 305);
			}
		});

		$(document).on('keydown', '.tabs .nav-pills a', function (event) {
			const list = this.closest('.nav-pills');

			const focusFirstElement = () => {
				$(list).find('a:first-child').focus();
			};
			const focusLastElement = () => {
				$(list).find('a:last-child').focus();
			};
			const focusNextElement = () => {
				this.nextElementSibling.focus()
			};
			const focusPrevElement = () => {
				this.previousElementSibling.focus();
			};

			if(event.key === "ArrowLeft") {
				focusPrevElement();
			}
			if(event.key === "ArrowRight") {
				focusNextElement()
			}
			if(event.key === "Home") {
				event.preventDefault();
				focusFirstElement()
			}
			if(event.key === "End") {
				event.preventDefault();
				focusLastElement();
			}
		});


		//footer dropdown slide
		$dropdown.on('show.bs.dropdown', function (e) {
			$(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
		});

		$dropdown.on('hide.bs.dropdown', function (e) {
			$(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
		});

		$(".aria-true").each(function () {
			$(this).attr('aria-expanded', 'true');
		});

		$("a[target='_blank']").each(function () {
			var title = $(this).attr('title');
			if (typeof title !== 'undefined' && title !== null) {
				//$(this).attr('title', 'Strona otworzy się w nowym oknie: ' + title);
			} else {
				$(this).attr('title', 'Strona otworzy się w nowym oknie');
			}
		});

		$('ul#site-menu').on('keyup', function (e) {
			const $a = $(this).find('>li.menu-item-has-children.open>a');
			if (!$a.length || e.key !== 'Escape') return;
			$a.click()
		})


		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			const withFocus = $(this).hasClass('with-focus');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top - 140
				}, 1000, function () {
					if (withFocus) {
						$(href)[0].focus();
						if ($(href).hasClass('tooltipstered')) {
							$(href).trigger('mouseover');
						}
					}
				});
			}
			$(href).focus();
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Menu mobile toggle
		$(".menu-toggle").click(function () {
			$('.menu-overlay').slideToggle();
			$headerContainer.toggleClass('menu-open');
			$(this).toggleClass("open");
			$(this).attr('aria-expanded', function (i, attr) {
				return attr === 'true' ? 'false' : 'true'
			});

			$("#site-menu > li.menu-item-has-children.open").each(function () {
				toggleChildrenLi($(this));
			})
		});
		const $headerContainer = $('.header-container');
		const mobileMenuMQ = window.matchMedia('(max-width: 1050px)');
		mobileMenuMQ.addEventListener('change', function (e) {
			$('.menu-overlay').css('display', '');
			$('.menu-toggle').removeClass('open').attr('aria-expanded', 'false');
			$headerContainer.removeClass('menu-open');
		})

		$("#site-menu li.menu-item-has-children > a").on('click', function (e) {
			e.preventDefault();
		});

		$("#site-menu li.menu-item-has-children > ul, #site-menu li.menu-item-has-children > ul > li").on('click', function (e) {
			e.stopPropagation();
		});

		function toggleChildrenLi($li) {
			const isOpen = $li.hasClass('open');
			$li.siblings('li').children('ul').slideUp();
			$li.siblings('li').removeClass('open');
			$("#site-menu").find(">li>a").each(function () {
				if ($(this).parent().hasClass('menu-item-has-children')) {
					$(this).attr('aria-expanded', false);
				}
			})
			$li.toggleClass('open');
			if ($li.hasClass('open')) {
				$li.find(">a").attr('aria-expanded', true);
			}

			if (!isOpen) {
				$li.children('ul').css({ display: 'flex' }).hide();
				$headerContainer.addClass('submenu-open');
			} else {
				$headerContainer.removeClass('submenu-open');
			}

			$li.children('ul').slideToggle({
				start: function () {
					$(this).css({
						display: "flex"
					})
				}
			});
		}

		$("#site-menu > li.menu-item-has-children").click(function () {
			toggleChildrenLi($(this));
		});

		var toolsInitialWidth = $(".tools").width();
		$('.search-trigger').click(function (e) {
			if ($(".search-container").is(":visible")) {
				$(".tools").animate({
					width: toolsInitialWidth
				});
				$(".search-container").animate({
					width: "0px"
				}, 200, function () {
					$(".search-container").hide();
				});
				if ($(document).width() < 700 && $(document).width() > 500) {
					$(".header-top .report-name").fadeTo(300, 1);
				}
			} else {
				$(".tools").animate({
					width: toolsInitialWidth + 200
				});
				if ($(document).width() < 700) {
					$(".header-top .report-name").fadeTo(300, 0);
				}
				$(".search-container").show();
				if ($(document).width() < 500) {
					$(".search-container").animate({
						width: "160px"
					});
				} else {
					$(".search-container").animate({
						width: "200px"
					});
				}
				$('#search-input').focus();
			}
			e.preventDefault();
			return false;
		});

		const updateBreadcrumbTop = () => {
			$headerContainer.innerHeight();
		}

	});
}(jQuery));
